import * as React from 'react';
import {connect} from 'react-redux';
import {makeStyles} from '@material-ui/core';
import {IArticleTarget} from '@app-types/article.types';
import {openArticle} from '@services/article/article.actions';
import {articleTargetForLink} from '@containers/knowledge/articleNavigation';
import Button from './button/Button';

interface IProps {
  article: string | IArticleTarget;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  openArticle: (target: IArticleTarget) => void;
}

// Neither a <button> nor the inline-flex box of a button label can break across lines. A span
// with an inline label lets a link in a sentence wrap with the words around it.
const useStyles = makeStyles({
  label: {
    display: 'inherit',
  },
});

function ArticleLink({article, children, className, style, openArticle: showArticle}: IProps) {
  const classes = useStyles();
  const target = typeof article === 'string' ? articleTargetForLink(article) : article;
  return (
    <Button component="span" variant="text" className={className} disabled={!target} classes={{label: classes.label}}
      style={{display: 'inline', minWidth: 0, padding: 0, font: 'inherit', textTransform: 'none',
        verticalAlign: 'baseline', textDecoration: 'underline', ...style}}
      onClick={event => {
        event.stopPropagation();
        if (target) showArticle(target);
      }}>
      {children}
    </Button>
  );
}

export default connect(null, {openArticle})(ArticleLink);



// WEBPACK FOOTER //
// ./src/components/common/ArticleLink.tsx